module.exports = __webpack_public_path__ + "media/images/lock_green-09a7311421f49ee18b03fcfa574e4849.svg";